import { render, staticRenderFns } from "./NavbarPlayer.vue?vue&type=template&id=25142ef9&"
import script from "./NavbarPlayer.vue?vue&type=script&lang=js&"
export * from "./NavbarPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports